import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./banner.html";
class Banner extends LightningElement {
  constructor(...args) {
    super(...args);
    this.title = void 0;
    this.titleColor = void 0;
    this.image = void 0;
    this.imageAlt = void 0;
    this.imageOnly = void 0;
    this.imageCaption = void 0;
    this.imageAlignment = void 0;
    this.imagePosition = void 0;
    this.bannerHeight = void 0;
    this.backgroundColor = void 0;
    this.backgroundImage = void 0;
    this.backgroundFocalX = void 0;
    this.backgroundFocalY = void 0;
    this.transparentImage = void 0;
    this.content = void 0;
    this.contentColor = void 0;
    this.textContentAlignment = void 0;
    this.contentFontSize = void 0;
    this.ctaText = void 0;
    this.ctaLink = void 0;
    this.ctaTarget = void 0;
    this.selectedBackdrop = void 0;
    this.backdropUrl = void 0;
    this.variant = void 0;
  }
  get wrapperClass() {
    const variantClass = this.variant ? `is-style-${this.variant}` : 'is-style-solid';
    return `axwp-banner__wrapper ${variantClass}`;
  }
  get blockClass() {
    let bannerClass = 'axwp-banner';
    if (this.imageOnly || !this.shouldDisplayContent) {
      bannerClass += ' axwp-banner--image-only';
    }
    if (this.backgroundImage?.length) {
      bannerClass += ' axwp-banner--background-image';
    }
    if (this.imageAlignment?.length) {
      bannerClass += ` axwp-banner--image-${this.imageAlignment}`;
    }
    return bannerClass;
  }
  get containerClass() {
    return `axwp-banner__container ${this.hasBackdrop ? 'has-backdrop' : ''}`;
  }
  get contentWrapperClass() {
    if (!this.imageOnly && !this.hasBackdrop) {
      return `axwp-banner__content__wrapper axwp-banner__content__wrapper--${this.imagePosition || 'right'}-image`;
    }
    return 'axwp-banner__content__wrapper';
  }
  get titleClass() {
    return `axwp-banner__title align${this.textContentAlignment || 'left'}`;
  }
  get contentClass() {
    let contentClass = `axwp-banner__content-text align${this.textContentAlignment || 'left'}`;
    if (this.contentFontSize !== 'default') {
      contentClass += ` axwp-banner__content-text--${this.contentFontSize}`;
    }
    return contentClass;
  }
  get ctaClass() {
    return `axwp-banner__cta align${this.textContentAlignment || 'left'}`;
  }
  get ctaDesktopClass() {
    return `${this.ctaClass} axwp-banner__cta--desktop`;
  }
  get ctaMobileClass() {
    return `${this.ctaClass} axwp-banner__cta--mobile`;
  }
  get imageClass() {
    let classes = 'axwp-banner__image';
    if (this.hasBackdrop) {
      classes += ` has-backdrop ${this.selectedBackdrop}`;
    }
    if (!this.transparentImage || this.transparentImage !== 'true') {
      classes += ' axwp-banner__image--opaque';
    }
    return classes;
  }
  get backdropClass() {
    return `axwp-banner__backdrop ${this.selectedBackdrop}`;
  }
  get wrapperStyle() {
    let style = '';
    if (this.backgroundColor?.length) {
      style += `--banner-background-color: ${this.backgroundColor};`;
    }
    return style;
  }

  /**
   * Get background image styles for block component.
   */
  get blockStyle() {
    let style = '';
    if (this.backgroundImage?.length) {
      style += `background-image: url(${this.backgroundImage});`;
      style += `background-size: auto;`;
      style += `background-repeat: no-repeat;`;
      if (this.backgroundFocalX && this.backgroundFocalY) {
        style += `background-position: ${this.backgroundFocalX * 100}% ${this.backgroundFocalY * 100}%;`;
      }
    }
    if (this.bannerHeight?.length) {
      style += `min-height: ${this.bannerHeight}px;`;
    }
    return style;
  }
  get titleStyle() {
    if (this.titleColor === '') {
      return null;
    }
    return `color: ${this.titleColor}`;
  }
  get contentStyle() {
    if (this.contentColor === '') {
      return null;
    }
    return `color: ${this.contentColor}`;
  }

  /**
   * Set image height variable
   */
  get imageStyle() {
    let style = '';
    let imageHeight = this.bannerHeight?.length ? this.bannerHeight : 450;
    if (imageHeight && Number(imageHeight) > 450) {
      imageHeight = 450;
    }
    style += `--banner-image-max-height: ${imageHeight}px;`;
    return style;
  }
  get hasTitle() {
    return this.title?.length > 0;
  }
  get hasContentText() {
    return this.content?.length > 0;
  }
  get hasCta() {
    return this.ctaText?.length && this.ctaLink?.length;
  }
  get hasImageCaption() {
    return this.imageCaption?.length;
  }
  get hasBackdrop() {
    return this.selectedBackdrop?.length > 0 && this.backdropUrl?.length > 0;
  }
  get shouldDisplayContent() {
    return !this.imageOnly && (this.hasTitle || this.hasContentText || this.hasCta);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Banner, {
  publicProps: {
    title: {
      config: 0
    },
    titleColor: {
      config: 0
    },
    image: {
      config: 0
    },
    imageAlt: {
      config: 0
    },
    imageOnly: {
      config: 0
    },
    imageCaption: {
      config: 0
    },
    imageAlignment: {
      config: 0
    },
    imagePosition: {
      config: 0
    },
    bannerHeight: {
      config: 0
    },
    backgroundColor: {
      config: 0
    },
    backgroundImage: {
      config: 0
    },
    backgroundFocalX: {
      config: 0
    },
    backgroundFocalY: {
      config: 0
    },
    transparentImage: {
      config: 0
    },
    content: {
      config: 0
    },
    contentColor: {
      config: 0
    },
    textContentAlignment: {
      config: 0
    },
    contentFontSize: {
      config: 0
    },
    ctaText: {
      config: 0
    },
    ctaLink: {
      config: 0
    },
    ctaTarget: {
      config: 0
    },
    selectedBackdrop: {
      config: 0
    },
    backdropUrl: {
      config: 0
    },
    variant: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Banner, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;